import { gql } from '@apollo/client';

const schema = {
  get: {
    name: 'order',
    serviceName: 'auth',
    query: gql`
      query order($ids: [String], $for_admin: Int) {
        order(ids: $ids, for_admin: $for_admin) {
          data {
            shipping_cost
          }
        }
      }
    `,
  },
  update: {
    name: 'refundToWallet',
    serviceName: 'shopadmin',
    query: gql`
      mutation refundToWallet(
        $type_id: String!
        $order_id: String!
        $product_shop_ids: [String]
        $amount: String
        $description: String
      ) {
        refundToWallet(
          type_id: $type_id
          order_id: $order_id
          product_shop_ids: $product_shop_ids
          amount: $amount
          description: $description
        ) {
          messages
        }
      }
    `,
  },
};

export default schema;
